import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StockageService } from '@perval/shared';
import { ErrorsService } from '../../../../shared/errors/errors.service';

@Component({
  selector: 'app-sign-in-errors',
  templateUrl: './sign-in-errors.component.html',
  styleUrls: ['./sign-in-errors.component.scss'],
})
export class SignInErrorsComponent implements OnChanges {
  @Input() showErrorMsg!: boolean;
  @Input() showResetPasswordSuccessMsg!: boolean;
  @Input() showValidateSuccessMsg!: boolean;
  @Input() showSessionExpiredMsg!: boolean;
  @Input() showDefaultErrorMsg!: boolean;
  @Input() showUseIdnotErrorMsg!: boolean;
  @Input() showOrganismExistErrorMsg!: boolean;

  constructor(
    private readonly errorsService: ErrorsService,
    private readonly stockageService: StockageService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['showErrorMsg']?.currentValue ||
      changes['showSessionExpiredMsg']?.currentValue ||
      changes['showDefaultErrorMsg']?.currentValue
    ) {
      this.stockageService.clear();
    }
  }

  get defaultErrorMsg(): string {
    return this.errorsService.getError('DEFAULT');
  }
}
